import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api, scaricaFile } from "@/lib/api";
import { euro, dateIt } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { FileText } from "lucide-react";

export function VerbaliDialog({ open, onClose }) {
  const { data: verbali = [], isLoading } = useQuery({ queryKey: ["mag-rettifiche"], queryFn: async () => (await api.get("/magazzino/giacenze/rettifiche")).data });
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="verbali-dialog">
        <DialogHeader><DialogTitle>Verbali di rettifica inventario</DialogTitle></DialogHeader>
        <div className="divide-y divide-slate-100 border rounded-lg">
          {isLoading && <div className="p-4 text-sm text-slate-400">Caricamento…</div>}
          {!isLoading && verbali.length === 0 && <div className="p-6 text-sm text-slate-400 text-center" data-testid="verbali-vuoto">Nessuna rettifica registrata.</div>}
          {verbali.map((v) => (
            <div key={v.id} className="p-3 flex items-center gap-3 flex-wrap" data-testid={`verbale-${v.id}`}>
              <span className="font-mono text-sm">{dateIt(v.data)}</span>
              <span className="text-sm text-slate-700 flex-1 min-w-[160px]">{v.note}</span>
              <span className="text-xs text-slate-500">{v.dettaglio.length} articoli · {v.in_piu} in più, {v.in_meno} in meno</span>
              <span className={`font-mono text-sm font-semibold ${v.valore >= 0 ? "text-emerald-700" : "text-red-700"}`}>{v.valore > 0 ? "+" : ""}{euro(v.valore)}</span>
              <Button size="sm" variant="outline" onClick={() => scaricaFile(`/magazzino/giacenze/rettifiche/${v.id}/pdf`, (m) => toast.error(m))} data-testid={`verbale-pdf-${v.id}`}><FileText className="h-3.5 w-3.5 mr-1" /> PDF</Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
